var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{staticClass:"form-control",attrs:{"rows":"6"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)},"blur":_vm.saveDialogNote}})}
var staticRenderFns = []

export { render, staticRenderFns }